"use strict";

export function initInScope ($scope) {
    let $newsletterMainCat = $scope.find('.js-newsletter-categories__main');

    $newsletterMainCat.attr('aria-expanded', "false");

    $newsletterMainCat.on('change',function () {
        let $newsletterCategories = $(this).closest('.js-newsletter-categories').find('.js-newsletter-categories__sub');

        if ($(this).prop('checked')) {
            $newsletterCategories.removeAttr('hidden');
            $(this).attr('aria-expanded', "true");
        } else {
            $newsletterCategories.attr('hidden','hidden');
            $(this).attr('aria-expanded', "false");
        }
    });
}